// Use this for moving the widget to the top layer - e.g. for cropping / editing text
export const TOP_LAYER_Z_INDEX = 99999999;

// Widgets that allow links to be added use this prefix to identify page links
export const PAGE_LINK_PREFIX = 'page://';
